import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import he from './locales/he/he.json'

export const languageRes = {
    he: { translation: he },
}

i18n.use(initReactI18next).init({
    compatibiliyJSON: "v3", 
    lng: "he",
    fallbackLng: "he",
    lazy:true,
    resources: languageRes,
    keySeparator: false,
    interpolation: {
        escapeValue: false,
    },
});


export default i18n;